import { PhoneNumberUtil, PhoneNumberFormat } from "google-libphonenumber";

export const formatPhoneNumber = (phoneNumber: string) => {
  const phoneUtil = PhoneNumberUtil.getInstance();
  const parsedNumber = phoneUtil.parse(phoneNumber.trim(), "US");

  return phoneUtil.format(parsedNumber, PhoneNumberFormat.NATIONAL);
};
